
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`美術学校の学生は自由な時間を取ることが難しい。少しでも休める期間があるのならば、普段とは少し違ったことをしなくてはならない使命感に私は駆られた。そしてやってみたかったことがあったと私は思い出した。
近寄り難い地下空間。私はそこをいつか冒険してみたかった。何本もの配管にレトロな看板。薄汚れた壁と床、グラフティやステッカーが目立つ。夏に来るにはジメジメしすぎている。地上とは異なる風景。少し無秩序な空間。私は写真を撮りにそこに向かうことにした。`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;